import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";
import { Message } from "components/Atoms/Message";

export const DeletedRow = () => {
  return <Message type="error" className="flex justify-space-between">
    <div>{RESX.File.Deleted}</div>
    <PhosphorWarning />
  </Message>
}